export default __webpack_public_path__ + "locales/tr/JavascriptSdk.json?hash=342d8a09f29e77a6b89323e321a99277";